/* eslint-disable no-case-declarations */
import Alert from 'react-s-alert';
import { elementKeys, measurementKeys } from '../constants/elementProps';
import { dateSorter } from '../services/dateSorter';
import { defaultColorFilter } from '../constants/defaultValues';

const filters = JSON.parse(localStorage.getItem('filters') || 'null');

const defaultState = {
  filterProps: {
    location: filters ? filters.location : [],
    street: filters ? filters.street : [],
    line: filters ? filters.line : '',
    position: filters ? filters.position : '',
    materialType: filters ? filters.materialType : '',
    remarks: filters ? filters.remarks : '',
    rl: {
      min: filters ? filters.rl.min : '',
      max: filters ? filters.rl.max : '',
    },
    qd: {
      min: filters ? filters.qd.min : '',
      max: filters ? filters.qd.max : '',
    },
    date: {
      start: filters ? filters.date.start : '',
      end: filters ? filters.date.end : '',
    },
    applicationDate: {
      start: filters ? filters.applicationDate.start : '',
      end: filters ? filters.applicationDate.end : '',
    },
  },
  allElements: [],
  selectedElement: null,
  locations: [],
  materialTypes: [],
  positions: [],
  lines: [],
  measurementPins: [],
  error: '',
  displayedElementProps: JSON.parse(localStorage.getItem('elementProps')) || elementKeys.map((item) => ({item, checked: true})),
  displayedMeasurementProps: JSON.parse(localStorage.getItem('measurementProps')) || measurementKeys.map((item) => ({item, checked: elementKeys.includes(item)})),
  colorFilter: JSON.parse(localStorage.getItem('rlqd')) ? 'rlqd' : 'false',
  colorValues: JSON.parse(localStorage.getItem('rlqd')) || defaultColorFilter,
};

export default function Elements(state = defaultState, action) {
  switch (action.type) {
    case 'CLEAR_FILTERS':
      localStorage.setItem('filters', JSON.stringify({
        location: action.payload.location,
        street: action.payload.street,
        line: '',
        position: '',
        materialType: '',
        remarks: '',
        rl: {
          min: '',
          max: '',
        },
        qd: {
          min: '',
          max: '',
        },
        date: {
          start: '',
          end: '',
        },
        applicationDate: {
          start: '',
          end: '',
        },
      }));
      return {
        ...state,
        filterProps: {
          location: action.payload.location,
          street: action.payload.street,
          line: '',
          position: '',
          materialType: '',
          remarks: '',
          rl: {
            min: '',
            max: '',
          },
          qd: {
            min: '',
            max: '',
          },
          date: {
            start: '',
            end: '',
          },
          applicationDate: {
            start: '',
            end: '',
          },
        },
        selectedElement: null,
      };
    case 'ELEMENTS_INIT_SAVE_FILTER':
      localStorage.setItem('filters', JSON.stringify({
        ...state.filterProps,
        location: action.payload.location,
        street: action.payload.street,
      }));
      return {
        ...state,
        filterProps: {
          ...state.filterProps,
          location: action.payload.location,
          street: action.payload.street,
        },
      };
    case 'SET_REMARKS_FILTER':
      localStorage.setItem('filters', JSON.stringify({
        ...state.filterProps,
        remarks: action.payload,
      }));
      return {
        ...state,
        filterProps: {
          ...state.filterProps,
          remarks: action.payload,
        },
      };
    case 'SET_RL_FILTER':
      localStorage.setItem('filters', JSON.stringify({
        ...state.filterProps,
        rl: action.payload,
      }));
      return {
        ...state,
        filterProps: {
          ...state.filterProps,
          rl: action.payload,
        },
      };
    case 'SET_QD_FILTER':
      localStorage.setItem('filters', JSON.stringify({
        ...state.filterProps,
        qd: action.payload,
      }));
      return {
        ...state,
        filterProps: {
          ...state.filterProps,
          qd: action.payload,
        },
      };
    case 'SET_DATE_FILTER':
      localStorage.setItem('filters', JSON.stringify({
        ...state.filterProps,
        date: action.payload,
      }));
      return {
        ...state,
        filterProps: {
          ...state.filterProps,
          date: action.payload,
        },
      };
    case 'SET_APPLICATION_DATE_FILTER':
      localStorage.setItem('filters', JSON.stringify({
        ...state.filterProps,
        applicationDate: action.payload,
      }));
      return {
        ...state,
        filterProps: {
          ...state.filterProps,
          applicationDate: action.payload,
        },
      };
    case 'SET_LINE_FILTER':
      localStorage.setItem('filters', JSON.stringify({
        ...state.filterProps,
        line: action.payload,
      }));
      return {
        ...state,
        filterProps: {
          ...state.filterProps,
          line: action.payload,
        },
      };
    case 'SET_POSITION_FILTER':
      localStorage.setItem('filters', JSON.stringify({
        ...state.filterProps,
        position: action.payload,
      }));
      return {
        ...state,
        filterProps: {
          ...state.filterProps,
          position: action.payload,
        },
      };
    case 'SET_MATERIAL_TYPE_FILTER':
      localStorage.setItem('filters', JSON.stringify({
        ...state.filterProps,
        materialType: action.payload,
      }));
      return {
        ...state,
        filterProps: {
          ...state.filterProps,
          materialType: action.payload,
        },
      };
    case 'ELEMENT_GET_POSITION_FILTER':
      return {
        ...state,
        positions: action.payload,
      };
    case 'ELEMENT_GET_MATERIAL_TYPES_FILTER':
      return {
        ...state,
        materialTypes: action.payload,
      };
    case 'ELEMENT_GET_LINES_FILTER':
      return {
        ...state,
        lines: action.payload,
      };
    case 'ELEMENTS_GET_SUCCESS':
      return {
        ...state,
        allElements: action.payload,
      };
    case 'ELEMENT_GET_SUCCESS':
      localStorage.setItem('coords', JSON.stringify(action.payload.coordinates));
      return {
        ...state,
        allElements: state.allElements.map((item) => item.id === action.payload.id ? action.payload : item),
        selectedElement: {
          ...action.payload,
          measurements: action.payload.measurements.sort(dateSorter),
        },
      };
    case 'SET_SINGLE_ELEMENT_ID':
      const element = state.allElements.filter((item) => item.id === action.payload.id);
      if (element.length) {
        localStorage.setItem('coords', JSON.stringify(element[0].coordinates));
      }

      return {
        ...state,
        selectedElement: {
          ...action.payload,
          coordinates: element.length ? element[0].coordinates : [],
        },
      };
    case 'UNSELECT_ELEMENT':
      return {
        ...state,
        selectedElement: null,
      };
    case 'GET_FAIL':
      return {
        ...state,
        error: action.payload,
      };
    case 'RESET_ERROR':
      return {
        ...state,
        error: '',
      };
    case 'DISPLAY_ELEMENT_TOGGLE': {
      const selectedElements = state.displayedElementProps.map((item) => {
        if (item.item === action.payload) {
          return {
            ...item, checked: !item.checked,
          };
        }
        return item;
      });

      // check for min element count to show
      if (selectedElements.filter((item) => item.checked).length < 10) {
        Alert.warning('Minimum 10 element props can be displayed', {timeout: 2000});
        return state;
      }

      localStorage.setItem('elementProps', JSON.stringify(selectedElements));
      return {
        ...state,
        displayedElementProps: selectedElements,
      };
    }
    case 'DISPLAY_MEASUREMENT_TOGGLE': {
      const selectedMeasurement = state.displayedMeasurementProps.map((item) => {
        if (item.item === action.payload) {
          return {
            ...item, checked: !item.checked,
          };
        }
        return item;
      });

      // check for min element count to show
      if (selectedMeasurement.filter((item) => item.checked).length < 10) {
        Alert.warning('Minimum 10 measurement props can be displayed', {timeout: 2000});
        return state;
      }

      localStorage.setItem('measurementProps', JSON.stringify(selectedMeasurement));
      return {
        ...state,
        displayedMeasurementProps: selectedMeasurement,
      };
    }
    case 'ELEMENT_CREATE_SUCCESS':
      Alert.success('Element create successfully', {timeout: 2000});
      return {
        ...state,
        allElements: [...state.allElements, action.payload],
      };
    case 'ELEMENT_UPDATE_SUCCESS':
      Alert.success('Element updates successfully', {timeout: 2000});
      return {
        ...state,
        selectedElement: action.payload,
        allElements: state.allElements.map((item) => {
          if (item.id === action.payload.id) {
            return action.payload;
          }
          return item;
        }),
      };
    case 'ELEMENT_DELETE_SUCCESS':
      Alert.success('Element deleted successfully', {timeout: 2000});
      return {
        ...state,
        selectedElement: null,
        allElements: action.payload,
      };
    case 'MEASUREMENT_UPDATE_SUCCESS':
      Alert.success('Measurement updated successfully', {timeout: 2000});
      return {
        ...state,
        selectedElement: {
          ...state.selectedElement,
          measurements: state.selectedElement.measurements.map((item) => {
            if (item.id === action.payload.id) {
              return action.payload;
            }
            return item;
          }),
        },
      };
    case 'MEASUREMENT_CREATE_SUCCESS':
      Alert.success('Measurement created successfully', {timeout: 2000});
      return {
        ...state,
        selectedElement: {
          ...state.selectedElement,
          measurements: state.selectedElement.measurements.concat(action.payload).sort(dateSorter),
        },
      };
    case 'MEASUREMENT_DELETED_SUCCESS':
      Alert.success('Measurement deleted successfully', {timeout: 2000});
      return {
        ...state,
        selectedElement: {
          ...state.selectedElement,
          measurements: state.selectedElement.measurements.filter((item) => !action.payload.includes(item.id)),
        },
      };
    case 'FILTER_ELEMENTS_SUCCESS':
      return {
        ...state,
        allElements: action.payload,
        selectedElement: null,
      };
    case 'LOCATIONS_GET_SUCCESS':
      return {
        ...state,
        locations: action.payload,
      };
    case 'MEASUREMENT_FETCH_SUCCESS':
      return {
        ...state,
        measurementPins: action.payload,
      };
    case 'ADD_IMAGE':
      Alert.closeAll();
      Alert.success('Measurement image successfully uplouded', {timeout: 2000});
      return {
        ...state,
        selectedElement: {
          ...state.selectedElement,
          images: [...state.selectedElement.images, ...action.payload],
        },
      };
    case 'REMOVE_IMAGE':
      return {
        ...state,
        selectedElement: {
          ...state.selectedElement,
          images: state.selectedElement.images.filter((item) => item.id !== action.payload),
        },
      };
    case 'CHANGE_COLOR_FILTER':
      return {
        ...state,
        colorFilter: action.payload,
        colorValues: JSON.parse(localStorage.getItem(action.payload)) || {rl: [0, 1, 2, 3], qd: [0, 1, 2, 3]},
      };
    case 'CHANGE_COLOR_VALUE':
      if (action.payload.value !== 'false') {
        localStorage.setItem('rlqd', JSON.stringify(action.payload.arr));
      } else {
        localStorage.removeItem('rlqd');
      }
      return {
        ...state,
        colorFilter: action.payload.value,
        colorValues: action.payload.arr,
      };
    case 'HANDLE_ROTATE_IMAGE':
      return {
        ...state,
        selectedElement: {
          ...state.selectedElement,
          images: state.selectedElement.images.map((item) => {
            if (item.id === action.payload.id) {
              return {
                ...item,
                rotation: action.payload.rotation,
              };
            }

            return item;
          }),
        },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/elements.js